import { render, staticRenderFns } from "./EstoqueView.vue?vue&type=template&id=9b7dca02&scoped=true&"
import script from "./EstoqueView.vue?vue&type=script&setup=true&lang=js&"
export * from "./EstoqueView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EstoqueView.vue?vue&type=style&index=0&id=9b7dca02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7dca02",
  null
  
)

export default component.exports